export default __webpack_public_path__ + "static/media/pay-scales.f2e5155f.png";